import { useEffect } from "react";
import useUserAccount from "../hooks/userAccountHook";

const LuckyOrangeLoader = () => {
  const {user} = useUserAccount();

 useEffect(() => {
    if (
      process.env.REACT_APP_ENVIRONMENT === "production" &&
      user &&
      user.email &&
      !user.email.includes("brolly") &&
      !user?.isInternalAdmin()
    ) {
      // Prevent duplicate loading
      if (!window.__lo_script_loaded__) {
        const script = document.createElement("script");
        script.src = "https://tools.luckyorange.com/core/lo.js?site-id=91610418";
        script.async = true;
        document.head.appendChild(script);

        window.__lo_script_loaded__ = true;
      }
    }
  }, [user]);

  return null;
};

export default LuckyOrangeLoader;